module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ios-banner-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'OSS Configs',
          to: {
            path: '/landing-banners'
          },
          exact: true,
        },
        {
          text: 'Banner IOS',
          to: {
            path: '/ios-banners'
          },
          exact: true,
        },
        {
          text: _vm.$route.query.baru ?
            'Tambah Banner Ios' :
            'Ubah Banner Ios',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(_vm.$route.query.baru ? "Tambah Banner Ios" : "Ubah Banner Ios") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticStyle: {}
  }, [_c('v-card-title', [_vm._v(" Detail Banner ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    staticClass: "d-flex",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    key: _vm.keyimg,
    attrs: {
      "src": _vm.url ?
        _vm.url :
        _vm.data.image && _vm.data.image != '' ?
        _vm.data.image :
        require('@/assets/img/unavailable.png')
    }
  })])])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-btn', {
    staticClass: "pa-0 font-weight-bold dark--text",
    attrs: {
      "block": "",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.file.click()
      }
    }
  }, [_vm._v("\n                            Upload *\n                        ")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "d-none",
    attrs: {
      "id": "oss_config_ios_banner_image",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Rasio thumbnail foto 16:9\n                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Maximum size is 200 KB\n                    ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "border-left": "1px solid #f0f0f0"
    },
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    ID *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "oss_config_ios_banner_id",
      "placeholder": "ID",
      "required": "",
      "outlined": ""
    },
    on: {
      "keypress": function($event) {
        /\d/.test(
            String.fromCharCode(
              $event.keyCode
            )
          ) ?
          true :
          $event.preventDefault()
      },
      "change": function($event) {
        _vm.data.id = _vm.data.id.replace(/\D/g, '')
      }
    },
    model: {
      value: (_vm.data.id),
      callback: function($$v) {
        _vm.$set(_vm.data, "id", $$v)
      },
      expression: "data.id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    URL\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "oss_config_ios_banner_url",
      "placeholder": "Link",
      "required": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.link),
      callback: function($$v) {
        _vm.$set(_vm.data, "link", $$v)
      },
      expression: "data.link"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Type *\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "id": "oss_config_ios_banner_type",
      "required": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.type),
      callback: function($$v) {
        _vm.$set(_vm.data, "type", $$v)
      },
      expression: "data.type"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Show In Home\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "oss_config_ios_banner_status",
      "label": "Aktif",
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_home),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_home", $$v)
      },
      expression: "data.is_home"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Show In Live Class\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "oss_config_ios_banner_status",
      "label": "Aktif",
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_live_class),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_live_class", $$v)
      },
      expression: "data.is_live_class"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                    Review\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "oss_config_ios_banner_review",
      "label": "Aktif",
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_review),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_review", $$v)
      },
      expression: "data.is_review"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.query.baru),
      expression: "!$route.query.baru"
    }],
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "id": "oss_config_ios_banner_hapus",
      "depressed": "",
      "color": "redLight"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDelete($event)
      }
    }
  }, [_vm._v("Hapus")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-6 py-2 white--text",
    attrs: {
      "id": "oss_config_ios_banner_simpan",
      "depressed": "",
      "color": "blew"
    },
    on: {
      "click": function($event) {
        return _vm.upload()
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.upload(1);
        _vm.dialogConfirm.open = false;
        _vm.dialogConfirm.title = null;
        _vm.dialogConfirm.function = null;
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71712ac7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/oss_configs/components/ios_banners/Form.vue
// module id = 1943
// module chunks = 1